import { render } from "./FaceCarousel.vue?vue&type=template&id=46a31171&scoped=true"
import script from "./FaceCarousel.vue?vue&type=script&lang=js"
export * from "./FaceCarousel.vue?vue&type=script&lang=js"

import "./FaceCarousel.vue?vue&type=style&index=0&id=46a31171&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a31171"]])

export default __exports__